import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { FotobiometriaDisponibilidadeBloqueioService } from '../fotobiometria-bloqueio-disponibilidade.service';
import { FotobiometriaDisponibilidadeBloqueioModel } from '@core/models/gestao/fotobiometria-bloqueio-disponibilidade.model';

@Injectable({
  providedIn: 'root',
})
export class FotobiometriaDisponibilidadeBloqueioPorIdResolver implements Resolve<Observable<any>> {
  constructor(private _service: FotobiometriaDisponibilidadeBloqueioService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this._service.getById(route.params.id).pipe(
      map((res) => res),
      catchError(() => of(new FotobiometriaDisponibilidadeBloqueioModel())),
    );
  }
}
